// Generated from private.meeting_import_contract() by scripts/generate/meeting-import-contract.mjs. Do not edit.
export const MEETING_IMPORT_CONTRACT = {
  "chunk_max_chars": 12000,
  "chunk_overlap_chars": 500,
  "max_body_chars": 20000,
  "max_candidate_id_chars": 200,
  "max_candidates": 1000,
  "max_container_name_chars": 500,
  "max_filename_chars": 255,
  "max_media_bytes": 25000000,
  "max_path_chars": 512,
  "max_people_per_item": 20,
  "max_person_name_chars": 200,
  "max_quote_chars": 10000,
  "max_title_chars": 500,
  "max_transcript_chars": 1000000,
  "max_url_chars": 4096,
  "media_extensions": [
    "flac",
    "mp3",
    "mp4",
    "mpeg",
    "mpga",
    "m4a",
    "ogg",
    "wav",
    "webm"
  ],
  "media_mime_types": [
    "audio/flac",
    "audio/x-flac",
    "audio/mpeg",
    "audio/mp3",
    "audio/mp4",
    "video/mp4",
    "audio/mpga",
    "audio/x-m4a",
    "audio/m4a",
    "audio/ogg",
    "video/ogg",
    "audio/wav",
    "audio/x-wav",
    "audio/webm",
    "video/webm",
    "video/mpeg"
  ],
  "text_unit": "unicode_code_points"
} as const;
